import Vue from 'vue';
import { updateField } from 'vuex-map-fields';
import Hashids from 'hashids';
import _ from 'lodash';

const hashids = new Hashids('dachshund', 6, 'cdefhjkmnprtvwxy2345689');

export default {
  addNewModule: (state, module) => {
    state.playlist.modules.push(module);
  },
  closeSnackbar: (state) => {
    state.snackbar.open = false;
  },
  forceCloseSnackbar: (state) => {
    state.snackbar.open = false;
  },
  incrementPlaylistDesignerKey: (state) => {
    state.playlistDesignerKey += 1;
  },
  pushUsedBulbId: (state, bulbId) => {
    Vue.set(state.usedBulbIds, state.usedBulbIds.length, bulbId);
  },
  refreshSettings: (state) => {
    state.settingsKey += 1;
  },
  resetPassbackBulbs: (state) => {
    state.passbackBulbs = [];
  },
  setActiveLMB: (state, lmb) => {
    state.activePlaylistVideo = {};
    state.activeResourceLinkURL = {};
    state.activeTextElement = {};
    state.downloadResourceURL = null;
    state.PDFComplete = false;
    state.activeLMB.bulbId = lmb.bulbId;
    state.activeLMB.name = lmb.name;
    state.activeLMB.moduleId = lmb.moduleId;
    state.activeLMB.config = lmb.config;
    state.activeLMB.teacherToken = lmb.teacherToken || state.userToken;
  },
  setActiveModuleItemId: (state, itemId) => {
    state.activeModuleItemId = itemId;
  },
  setActivePlaylistVideo: (state, bulb) => {
    state.activeLMB = {};
    state.activeResourceLinkURL = {};
    state.activeTextElement = {};
    state.downloadResourceURL = null;
    state.PDFComplete = false;
    state.activePlaylistVideo.bulbId = bulb.id;
    state.activePlaylistVideo.name = bulb.name;
    if (bulb.scoreThreshold) state.activePlaylistVideo.scoreThreshold = bulb.scoreThreshold;
    else delete state.activePlaylistVideo.scoreThreshold;
    state.activePlaylistVideo.moduleId = bulb.moduleId;
    state.activePlaylistVideo.config = bulb.config;
  },
  setActiveResourceLinkURL: (state, resource) => {
    state.activeLMB = {};
    state.activePlaylistVideo = {};
    state.activeTextElement = {};
    state.downloadResourceURL = null;
    state.PDFComplete = false;
    state.activeResourceLinkURL = resource;
  },
  setActiveTextElement: (state, text) => {
    state.activeLMB = {};
    state.activePlaylistVideo = {};
    state.activeResourceLinkURL = {};
    state.downloadResourceURL = null;
    state.PDFComplete = false;
    state.activeTextElement.title = text.title;
    state.activeTextElement.body = text.body;
  },
  setAdobePDFError: (state, value) => {
    state.adobePDFError = value;
  },
  setAllBulbsInPlaylist: (state, bulbs) => {
    state.allBulbsInPlaylist = bulbs;
  },
  setAllModuleItemAttempts: (state, allModuleItems) => {
    Vue.set(state, 'allModuleItemAttempts', allModuleItems);
  },
  setAlreadyCopied: (state, value) => {
    state.alreadyCopied = value;
  },
  setBadgrLoaded: (state, value) => {
    state.badgrLoaded = value;
  },
  setCredlyLoaded: (state, value) => {
    state.credlyLoaded = value;
  },
  setCertificateBadge: (state, value) => {
    state.playlist.certificateBadge = value;
    state.certificateBadge = value;
  },
  setCertificateMessage: (state, value) => {
    state.playlist.certificateMessage = value;
    state.certificateMessage = value;
  },
  setCertificateSignature: (state, value) => {
    state.playlist.certificateSignature = value;
    state.certificateSignature = value;
  },
  setCopiedPlaylistHash: (state, value) => {
    state.copiedPlaylistHash = value;
  },
  setCourseCopy: (state, value) => {
    state.courseCopy = value;
  },
  setDownloadResourceURL: (state, value) => {
    state.activePlaylistVideo = {};
    state.activeResourceLinkURL = {};
    state.activeTextElement = {};
    state.downloadResourceURL = value;
  },
  setIsCompleted: (state, value) => {
    state.isCompleted = value;
  },
  setIsLoaded: (state, value) => {
    state.isLoaded = value;
  },
  setIsLti: (state, value) => {
    state.isLti = value;
  },
  setLti13Launch: (state, value) => {
    state.lti13Launch = value;
  },
  setHasPlaylistCertificateAccess: (state, value) => {
    state.hasPlaylistCertificateAccess = value;
  },
  setIsUpdating: (state, value) => {
    state.isUpdating = value;
  },
  setTags: (state, value) => {
    state.tags = value;
  },
  setLastPDFPage: (state, value) => {
    state.lastPDFPage = value;
  },
  setLoadingData: (state, value) => {
    state.loadingData = value;
  },
  setModuleSelected: (state, module) => {
    state.moduleSelected = module;
  },
  setNextItemTimeoutToast: (state, toast) => {
    if (state.nextItemToastTimeout) clearTimeout(state.nextItemToastTimeout);
    state.nextItemToastTimeout = toast;
  },
  setNsf: (state, value) => {
    state.nsf = value;
  },
  setPDFComplete: (state, value) => {
    state.PDFComplete = value;
  },
  setPlaylist: (state, playlist) => {
    Vue.set(state, 'playlistClone', _.cloneDeep(playlist));
    Vue.set(state, 'playlist', playlist);
  },
  setPlaylistAttempt: (state, attempt) => {
    state.playlistAttempt = attempt;
  },
  setPlaylistHasLMBs: (state, value) => {
    state.playlistHasLMBs = value;
  },
  setPlaylistId: (state, value) => {
    [state.playlistId, state.sectionId] = hashids.decode(value);
    state.courseHash = value;
  },
  setQueryParams: (state, urlSearchParams) => {
    state.queryParams = urlSearchParams;
  },
  setRequiredItemIndex: (state, itemIndex) => {
    state.requiredItemIndex = itemIndex;
  },
  setResourceLinkId: (state, resourceLinkId) => {
    state.resourceLinkId = resourceLinkId;
  },
  setSectionId: (state, sectionId) => {
    state.sectionId = sectionId;
  },
  setSlideout: (state, slideout) => {
    state.showSlideout = !!slideout;
    Vue.set(state, 'slideoutData', slideout);
  },
  setStudentSubmissionId: (state, submissionId) => {
    state.studentSubmissionId = submissionId;
  },
  setUsedItemsInPlaylist: (state) => {
    state.usedBulbIds = [];
    state.usedAttachmentIds = [];
    // Create a list of all bulbIds currently in use
    for (const module of state.playlist.modules) {
      for (const item of module.moduleItems) {
        if (item.type === 'bulb') Vue.set(state.usedBulbIds, state.usedBulbIds.length, item.itemId);
        else state.usedAttachmentIds.push(item.itemId);
      }
    }
  },
  setUserToken: (state, userToken) => {
    state.userToken = userToken;
  },
  toggleSnackbar: async (state, options) => {
    state.snackbar.open = false;
    await Vue.nextTick();
    state.snackbar = {
      action: options.action || false,
      color: options.color,
      open: true,
      text: options.text,
      timeout: _.isUndefined(options.timeout) ? 5000 : options.timeout,
    };
  },
  updateUser: (state, user) => {
    if (_.get(user, 'user_info', false)) {
      user.userInfo = JSON.parse(user.user_info);
      delete user.user_info;
    }
    Vue.set(state, 'user', user);
  },
  updateField,
  setLmsConsumerVersion: (state, value) => {
    state.lmsConsumerVersion = value;
  },
  setLmsIssuer: (state, value) => {
    state.lmsIssuer = value;
  },
};
